// extracted by mini-css-extract-plugin
export default {"searchResults":"KfaNRD"};